import { CITY_RESULT_FETCH_DATA_SUCCESS, CITY_RESULT_HAVE_ERROR, CITY_RESULT_ARE_LOADING } from '../actionType';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function CityResultAction(action, payload) {
    switch (action) {
        case CITY_RESULT_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };
    
        case CITY_RESULT_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };
    
        case CITY_RESULT_FETCH_DATA_SUCCESS:
            return {
                type: action,
                cityResult: payload,
            };

        default:
            return;
    }
}

export function CityResultFetchData(city) {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(CityResultAction(CITY_RESULT_ARE_LOADING, true));
                Get(HttpService.cityResult+city).then((result) => {
                    dispatch(CityResultAction(CITY_RESULT_FETCH_DATA_SUCCESS, result));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(CityResultAction(CITY_RESULT_HAVE_ERROR, true));
        }
    }
}
